var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from "react";
export var usePaymentModeSelection = function (setBodyPatchQuote, setTriggerPatchQuote) {
    var _a = useState("Plan anual"), periodPlanName = _a[0], setPeriodPlanName = _a[1];
    var _b = useState(""), paymentModeId = _b[0], setPaymentModeId = _b[1];
    var _c = useState(""), paymentModeName = _c[0], setPaymentModeName = _c[1];
    var onApplySelected = function (item) {
        var _a;
        switch (item.valueSelected.value) {
            case "MON":
                setPeriodPlanName("Plan mensual");
                break;
            case "ANU":
                setPeriodPlanName("Plan anual");
                break;
            default:
                setPeriodPlanName("Plan anual");
                break;
        }
        setPaymentModeId((_a = item === null || item === void 0 ? void 0 : item.valueSelected) === null || _a === void 0 ? void 0 : _a.id);
        setPaymentModeName(item.valueSelected.value);
        var payment = {
            id: item.valueSelected.id,
            description: item.valueSelected.name,
            code: item.valueSelected.value,
        };
        setBodyPatchQuote(function (prev) { return (__assign(__assign({}, prev), { catalogPaymentMode: payment === null || payment === void 0 ? void 0 : payment.id })); });
        setTriggerPatchQuote(true);
    };
    return {
        periodPlanName: periodPlanName,
        paymentModeId: paymentModeId,
        paymentModeName: paymentModeName,
        onApplySelected: onApplySelected,
        setPeriodPlanName: setPeriodPlanName,
        setPaymentModeId: setPaymentModeId,
        setPaymentModeName: setPaymentModeName,
    };
};
